module.exports = __webpack_public_path__ + "img/0Q3B1891_L_Foamcore_MockedUp.4a2fdb25.jpg";